import { PermitType } from '@/api/backend/types';
import { formatIsoDate } from '@/lib/utils';
import { ListTable, ListTableCell, ListTableHeader, ListTableRow } from '@opaz/ui-components';
import { useTranslation } from 'react-i18next';

type PermitsListTableProps = {
  className?: string;
  data: PermitType;
};

export const PermitsListTable = ({ data, className }: PermitsListTableProps) => {
  const { t, i18n } = useTranslation();

  const getTitleByRegistryCode = (registryCode: string): string => {
    return t([
      `registry.permit.sectionDetails.table.headings.registryCode.${registryCode}` as unknown as TemplateStringsArray,
      'registry.permit.sectionDetails.table.headings.permitGroup',
    ]) as string;
  };

  return (
    <ListTable className={className}>
      <ListTableRow>
        <ListTableHeader>{t('registry.permit.sectionDetails.table.headings.permitNumber')}</ListTableHeader>
        <ListTableCell>{data.registryNumber}</ListTableCell>
      </ListTableRow>

      {data.relatedRegistryNumber && (
        <ListTableRow>
          <ListTableHeader>{getTitleByRegistryCode(data.registryCode)}</ListTableHeader>
          <ListTableCell>{data.relatedRegistryNumber}</ListTableCell>
        </ListTableRow>
      )}

      <ListTableRow>
        <ListTableHeader>{t('registry.permit.sectionDetails.table.headings.beneficiary')}</ListTableHeader>
        <ListTableCell>
          <div>
            <p className="font-medium">{i18n.language === 'ar' ? data.party2NameAr : data.party2NameEn}</p>
            <p className="text-sm text-muted-foreground">{data.party2}</p>
          </div>
        </ListTableCell>
      </ListTableRow>

      <ListTableRow>
        <ListTableHeader>{t('registry.permit.sectionDetails.table.headings.permitGroup')}</ListTableHeader>
        <ListTableCell>
          {t([`backend.codes.${data.registryGroupCode}` as unknown as TemplateStringsArray, 'common.unknown'])}
        </ListTableCell>
      </ListTableRow>

      <ListTableRow>
        <ListTableHeader>{t('registry.permit.sectionDetails.table.headings.zone')}</ListTableHeader>
        <ListTableCell>{t([`common.zoneCode.${data.zoneCode}`, 'common.unknown'])}</ListTableCell>
      </ListTableRow>

      <ListTableRow>
        <ListTableHeader>{t('registry.permit.sectionDetails.table.headings.issueDate')}</ListTableHeader>
        <ListTableCell>{formatIsoDate(data.startDate, i18n.language)}</ListTableCell>
      </ListTableRow>

      <ListTableRow>
        <ListTableHeader>{t('registry.permit.sectionDetails.table.headings.expiryDate')}</ListTableHeader>
        <ListTableCell>{formatIsoDate(data.endDate, i18n.language)}</ListTableCell>
      </ListTableRow>
    </ListTable>
  );
};
